/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { BillingMetadata } from '../models/billing-metadata';

/**
 * Ui Billing Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiBillingControllerService extends __BaseService {
  static readonly buySupportPlanUsingPOSTPath =
    '/cc-ui/v1/billing/buy-support-plan';
  static readonly startStripeCustomerPortalSessionUsingGETPath =
    '/cc-ui/v1/billing/manage-billing';
  static readonly getBillingMetadataUsingGETPath = '/cc-ui/v1/billing/metadata';
  static readonly reportUsageUsingGETPath = '/cc-ui/v1/billing/report-usage';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * buySupportPlan
   * @param params The `UiBillingControllerService.BuySupportPlanUsingPOSTParams` containing the following parameters:
   *
   * - `successUrl`: successUrl
   *
   * - `cancelUrl`: cancelUrl
   *
   * @return OK
   */
  buySupportPlanUsingPOSTResponse(
    params: UiBillingControllerService.BuySupportPlanUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.successUrl != null)
      __params = __params.set('successUrl', params.successUrl.toString());
    if (params.cancelUrl != null)
      __params = __params.set('cancelUrl', params.cancelUrl.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/billing/buy-support-plan`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * buySupportPlan
   * @param params The `UiBillingControllerService.BuySupportPlanUsingPOSTParams` containing the following parameters:
   *
   * - `successUrl`: successUrl
   *
   * - `cancelUrl`: cancelUrl
   *
   * @return OK
   */
  buySupportPlanUsingPOST(
    params: UiBillingControllerService.BuySupportPlanUsingPOSTParams,
  ): __Observable<string> {
    return this.buySupportPlanUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as string),
    );
  }

  /**
   * startStripeCustomerPortalSession
   * @param returnUrl returnUrl
   * @return OK
   */
  startStripeCustomerPortalSessionUsingGETResponse(
    returnUrl: string,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (returnUrl != null)
      __params = __params.set('returnUrl', returnUrl.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/billing/manage-billing`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * startStripeCustomerPortalSession
   * @param returnUrl returnUrl
   * @return OK
   */
  startStripeCustomerPortalSessionUsingGET(
    returnUrl: string,
  ): __Observable<string> {
    return this.startStripeCustomerPortalSessionUsingGETResponse(
      returnUrl,
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * getBillingMetadata
   * @return OK
   */
  getBillingMetadataUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<BillingMetadata>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/billing/metadata`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BillingMetadata>>;
      }),
    );
  }
  /**
   * getBillingMetadata
   * @return OK
   */
  getBillingMetadataUsingGET(): __Observable<Array<BillingMetadata>> {
    return this.getBillingMetadataUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<BillingMetadata>),
    );
  }

  /**
   * reportUsage
   */
  reportUsageUsingGETResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/billing/report-usage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * reportUsage
   */
  reportUsageUsingGET(): __Observable<null> {
    return this.reportUsageUsingGETResponse().pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiBillingControllerService {
  /**
   * Parameters for buySupportPlanUsingPOST
   */
  export interface BuySupportPlanUsingPOSTParams {
    /**
     * successUrl
     */
    successUrl: string;

    /**
     * cancelUrl
     */
    cancelUrl: string;
  }
}

export { UiBillingControllerService };
